import React from 'react';
import {Card, CardText, CardBody, CardTitle, CardSubtitle} from 'reactstrap';
import PropTypes from 'prop-types';
import '../scss/_salesHistoryCard.scss';
import { getFormattedCurrency, formatActivityDateWithYear } from './utils';

class SalesHistoryCard extends React.Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        
        this.state = {
            columns: ['Event','Date','Price','Price/Sq Ft.','Days on Market'],
            data: props.listing.SalesHistory,
            cardExpanded: false  
        }
        
    }

    render() {
        const viewMore = this.state.data.length > 5 ? "View "+ (this.state.data.length - 5)  +" More" : "";

        return (<div className='report_table_container'>
            <div className="col-12 mg-topbtm-20">
                <h3 className="sales_history_card_header">Sales History</h3>
                {this.state.data.length > 0 ? this.state.data.map((item,i) => {
                    const card = i <= 4 || this.state.cardExpanded ? 
                    <Card className='sales_history_card'>
                        <CardBody>
                            <CardTitle className='sales_histotry_card_title'>
                                <h5>
                                    {item.Event}
                                </h5>
                            </CardTitle>
                            <CardSubtitle className='sales_histotry_card_sub_title'>{formatActivityDateWithYear(item.Date)}</CardSubtitle>
                            <CardText className='sales_history_card_text'>
                                    <span className='sales_history_price'>{getFormattedCurrency(item.Price)}</span>
                                    <span className='bulletPoint'>{isFinite(item.PricePerSqft) ? getFormattedCurrency(item.PricePerSqft) + '/SqFt': '-'}</span>
                                    <span className='bulletPoint'>{item.DaysOnMarket + ' Days on Market'}</span>
                            </CardText>
                        </CardBody>
                    </Card> : null;
                    return [
                       card     
                    ];
                }) 
                : <div className='no_sale_card'>No Sales History Available</div>} 
                <button className="btn btn-link view_btn" onClick={() => this.setState({ cardExpanded: !this.state.cardExpanded })}>
                            {this.state.cardExpanded ? 'View Less' : viewMore}
                </button>
            </div>
        </div>)
    }
}

export default SalesHistoryCard;